import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ACCESS_TOKEN } from '../constants/app-strings';

@Injectable({
  providedIn: 'root',
})
export class InvestorGuard implements CanActivate {
  constructor(private readonly router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const token = localStorage.getItem(ACCESS_TOKEN);
    if (token) return true;
    else return this.router.navigateByUrl('/');
  }
}
